export default __webpack_public_path__ + "static/media/mdi_rupee.cde4c6aa.svg";